// ---------------------------------------------------------------------------
// IMAGE ASSETS — official Barverse architectural renders (approved owner art).
// Swap the files in public/images or update paths here as new renders arrive.
// ---------------------------------------------------------------------------
export const MEDIA = {
  hero: {
    src: "/images/barverse-bar-hero.webp",
    alt: "Architectural rendering of the Barverse bar — chrome bar stools, brick walls, a glowing Barverse neon sign and two big-screen TVs over the backbar",
  },
  welcome: {
    src: "/images/barverse-exterior.webp",
    alt: "Architectural rendering of the Tacoverse and Barverse building exterior — both brand signs over one shared storefront",
  },
  sports: {
    src: "/images/barverse-bar-wide.webp",
    alt: "Architectural rendering of the Barverse bar — red backlit bar counter with chrome stools, wood floor, glowing Barverse neon sign and big-screen TVs showing baseball",
  },
  groups: {
    src: "/images/barverse-bar-wide.webp",
    alt: "Architectural rendering of the Barverse bar — red backlit bar counter with chrome stools, wood floor, glowing Barverse neon sign and big-screen TVs showing baseball",
  },
  exterior: {
    src: "/images/barverse-exterior.webp",
    alt: "Architectural rendering of the Tacoverse and Barverse building exterior — both brand signs over one shared storefront",
  },
};
